import {
  PAYMENT_KINDS,
  type PaymentKind,
  type PaymentMethod,
  type PaymentMethodInput,
} from '@/domain/entities/payment-method.entity'
import type { PaymentMethodDto } from './payment-method.dto'

/**
 * `kind` datang sebagai string bebas dari jaringan. Nilai asing dipetakan ke
 * `other` — enum BE bisa bertambah lebih dulu (mis. saat QRIS dinamis rilis),
 * dan itu bukan alasan untuk membuat seluruh tabel gagal render.
 */
function toKind(raw: string): PaymentKind {
  return (PAYMENT_KINDS as readonly string[]).includes(raw) ? (raw as PaymentKind) : 'other'
}

/** String opsional: BE menyimpan string kosong sebagai NULL, samakan di FE. */
function toBody(input: PaymentMethodInput) {
  return {
    name: input.name,
    kind: input.kind,
    image_url: input.imageUrl ?? '',
    url_qris_statis: input.urlQrisStatis ?? '',
    allow_change: input.allowChange,
    require_reference: input.requireReference,
    account_name: input.accountName ?? '',
    account_number: input.accountNumber ?? '',
    provider: input.provider ?? '',
    sort_order: input.sortOrder,
  }
}

export const paymentMethodMapper = {
  toPaymentMethod(dto: PaymentMethodDto): PaymentMethod {
    return {
      id: dto.id,
      name: dto.name,
      kind: toKind(dto.kind),
      imageUrl: dto.image_url || null,
      urlQrisStatis: dto.url_qris_statis || null,
      allowChange: dto.allow_change ?? false,
      requireReference: dto.require_reference ?? false,
      accountName: dto.account_name || null,
      accountNumber: dto.account_number || null,
      provider: dto.provider || null,
      sortOrder: dto.sort_order ?? 0,
      // Baris baru selalu aktif di BE; anggap aktif bila field-nya absen.
      active: dto.active ?? true,
    }
  },

  toBody,
}
